(() => {
  function prepare(popover) {
    if (!popover?.matches?.('x-popover')) return;
    const options = popover?.querySelector('template[data-cc-country-options]');
    if (options) options.replaceWith(options.content);
  }

  function prepareFromControl(event) {
    const control = event.target.closest?.('.localization-toggle[aria-controls]');
    if (control) prepare(document.getElementById(control.getAttribute('aria-controls')));
  }

  document.addEventListener('pointerover', prepareFromControl, { passive: true, capture: true });
  document.addEventListener('pointerdown', prepareFromControl, { passive: true, capture: true });
  document.addEventListener('focusin', prepareFromControl, true);
  document.addEventListener('click', prepareFromControl, true);
  document.addEventListener('dialog:before-show', (event) => prepare(event.target), true);

  const switchedLists = new Set();
  let resizeFrame;
  let viewportWidth = window.innerWidth;

  function sizeImages(list) {
    if (!list.isConnected) {
      switchedLists.delete(list);
      return;
    }
    const media = list.querySelector('product-card .product-card__media');
    const width = media?.getBoundingClientRect().width;
    if (!width) return;
    const sizes = `${Math.ceil(width)}px`;
    list.querySelectorAll('product-card img.product-card__image[srcset]').forEach((image) => {
      if (image.getAttribute('sizes') !== sizes) image.setAttribute('sizes', sizes);
    });
  }

  document.addEventListener('click', (event) => {
    const control = event.target.closest?.('collection-layout-switch');
    if (!control || !event.target.closest?.('button')) return;
    const list = document.getElementById(control.getAttribute('aria-controls'));
    if (!list) return;
    switchedLists.add(list);
    requestAnimationFrame(() => sizeImages(list));
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth === viewportWidth) return;
    viewportWidth = window.innerWidth;
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => switchedLists.forEach(sizeImages));
  }, { passive: true });
})();
